var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAbout = function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#about_svg__a)",
    d: "m18.689 6.53-.705.258.704-.259Zm-8.34-.383-.717-.224a.75.75 0 0 0 1.432.449l-.716-.225ZM3.282 1.68l-.429-.615.43.615ZM6.87 17.2l-.5.559.253.226.337-.04-.09-.745ZM19.393 6.271c-.89-2.427-3.018-3.536-5.05-3.537-1.998 0-4.054 1.087-4.71 3.189l1.431.447c.413-1.32 1.759-2.136 3.28-2.136 1.487 0 2.995.794 3.64 2.554l1.409-.517Zm-8.33.1c.661-2.1-.404-4.169-2.043-5.313-1.666-1.163-4.046-1.472-6.166.007l.859 1.23c1.536-1.072 3.227-.86 4.448-.007 1.248.87 1.887 2.312 1.472 3.634l1.43.45Zm-8.21-5.305C.655 2.603-.144 5.336.434 8.344c.576 3.005 2.525 6.362 5.937 9.415l1-1.118c-3.23-2.89-4.964-5.972-5.465-8.58-.5-2.607.228-4.662 1.808-5.766l-.86-1.23ZM6.96 17.945c4.542-.55 8.06-2.187 10.253-4.32 2.194-2.135 3.104-4.834 2.18-7.354l-1.409.517c.664 1.809.085 3.91-1.817 5.762-1.904 1.852-5.088 3.385-9.387 3.906l.18 1.489Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "about_svg__a",
    x1: 1,
    x2: 3.14,
    y1: 0.817,
    y2: 19.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })))));
};
export default SvgAbout;